import store from '../store'
import IconStyle from 'ol/style/Icon'
import Style from 'ol/style/Style'
import Select from 'ol/interaction/Select'
import DroneImageView from '../components/map/DroneImageView'

export default {
  created () {
    this.selectInteraction = null
  },
  methods: {
    injectStyle() {
      this.$mapService.walkTree(store.getters['map/layersTree'], node => {
        if (node['name'] === 'v4:drone_photo_points') {
          node['definedStyle'] = (feature, resolution) => {
            return [new Style({
              'image': new IconStyle({
                src: `/api/layers/drone-img-thumbnail/?id=${feature.get('id')}&img_type=thumbnail`
              })
            })]
          }

        }
      })
    },
    initClick(layer) {
      if (this.selectInteraction) {
        return
      }
      this.selectInteraction = new Select({
        hitTolerance: 8,
        layers: [layer],
        multi: false
      })

      this.selectInteraction.on('select', this.featureSelected, this)
      this.selectInteraction.on('deselect', this.featureSelected, this)
      this.$mapService.map.addInteraction(this.selectInteraction)
    },
    unInitClick() {
      this.$mapService.map.removeInteraction(this.selectInteraction)
      this.selectInteraction = null
    },
    showImage() {},
    featureSelected (e) {
      if (!e.selected.length) {
        return
      }
      let f = e.selected.map(f =>  {
        let p = f.getProperties()
        return {
          'id': p['id'],
          'name': p['name'],
          'date_created': p['date_created']
        }
      })
      let opts = {
        available: true,
        enabled: true,
        clazz: DroneImageView,
        w: 3,
        h: 4,
        x: 3,
        y: 0,
        propsData: {
          features: f
        },
        destroyable: true
      }

      this.$store.commit('cmp/update', {
        cmp: f[0]['id']+'drone_view',
        payload: opts
      })
    }
  },
  computed: {
    layersSorted () {
      return store.getters['map/layersSorted']
    }
  },
  watch: {
    layersSorted (val) {

      this.$mapService.walkTree(store.getters['map/layersTree'], node => {
        if (node['name'] === 'v4:drone_photo_points') {
          let layer = this.$mapService._layerExists(node)
          if (layer) {
            if (node['checked']) {
              this.initClick(layer)
            } else {
              this.unInitClick()
            }
          }


        }
      })

    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/DroneImageryMixin.js